// Chapter bar (sections/chapter-nav.liquid): one link per Chapter section, marking the one being read.
if (!customElements.get('klpd-chapter-nav')) {
  customElements.define(
    'klpd-chapter-nav',
    class KlpdChapterNav extends HTMLElement {
      connectedCallback() {
        const chapters = [...document.querySelectorAll('[data-chapter-label]')];
        if (!chapters.length) return;

        const list = this.querySelector('.chapter-nav__list');
        list.replaceChildren();
        this.links = chapters.map((chapter) => {
          const item = document.createElement('li');
          const link = document.createElement('a');
          link.className = 'chapter-nav__link';
          link.href = `#${chapter.id}`;
          if (chapter.dataset.chapterNumber) {
            const number = document.createElement('span');
            number.className = 'chapter-nav__number';
            number.textContent = chapter.dataset.chapterNumber;
            link.append(number);
          }
          link.append(chapter.dataset.chapterLabel);
          item.append(link);
          list.append(item);
          return link;
        });
        this.hidden = false;

        const mark = (id) => {
          this.links.forEach((link) => {
            const current = link.getAttribute('href') === `#${id}`;
            link.setAttribute('aria-current', current ? 'true' : 'false');
            // Keep the current chapter in view on narrow screens, without moving the page
            if (current) list.scrollTo({ left: link.parentElement.offsetLeft - 16, behavior: 'smooth' });
          });
        };
        mark(chapters[0].id);

        if (!('IntersectionObserver' in window)) return;
        const observer = new IntersectionObserver(
          (entries) => {
            const visible = entries.filter((entry) => entry.isIntersecting);
            if (visible.length) mark(visible[0].target.id);
          },
          { rootMargin: '-30% 0px -60% 0px' }
        );
        chapters.forEach((chapter) => observer.observe(chapter));
      }
    }
  );
}
